function renderCards() {
  // Loops through the product cards and creates a slider for each
  var card = 0;
  $('.media.slick').each(function(i, obj) {
    card++
    $(this).slick({
      lazyLoad: 'ondemand',              
      speed: 700,
      easing: 'linear',
      adaptiveHeight: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor" transform="translate(100, 100) rotate(180)"></path></svg></button>'
    });
  });
  
  $('.collection .card-wrapper').each(function(i, obj) {
    $(this).delay(i*200).queue(function() {
      $(this).addClass('loaded').dequeue();
    });
  });
}
renderCards();

window.addEventListener("resize", (event) => {
  $('.media.slick').each(function(i, obj) {
    $(this)[0].slick.refresh();
  });
});